var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"100%"}},[_c('v-card-title',{staticClass:"title"},[_vm._v("Chat with Customers")]),_c('Chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }